<div cdkDrag class="opacity-90 p-4 w-1/2 rounded-sm bg-dat-grey-200 text-dat-grey-900">
    <header
        class="flex justify-between items-center cursor-grab active:cursor-grabbing"
    >
        <h1 class="font-headline-5-strong">Content Editor</h1>
        @if(!collapsed()){
        <button (click)="collapsed.set(true)">
            <span class="material-symbols-outlined"> keyboard_arrow_down </span>
        </button>
        } @if(collapsed()){
        <button (click)="collapsed.set(false)">
            <span class="material-symbols-outlined"> keyboard_arrow_up</span>
        </button>
        }
    </header>
    @if(!collapsed()){
    <section class="p-4">
        <iq-controls-dashboard
            [fg]="fg"
            [id]="'tl-view-controls-content'"
            [controls]="controls()"
            (submitted)="onSubmit($event)"
        ></iq-controls-dashboard>
    </section>
    }
</div>
